import { Grid } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '../../../../app-context';
import IForm from '../../../../components/i-form/i-form.component';
import ITextField from '../../../../components/text-component/textfield/i-textfield.component';
import { isNotNull } from '../../../common/util.services';
import { getProcessById, saveProcess } from '../../production.services';
import './production-process-form.component.scss';

const ProductionProcessForm = (props: any) => {
  const [title, setTitle] = useState<string>('Add Process');
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const params = useParams()
  const rowId = params.rowId;
  const [processData, setProcessData] = useState<any>({});
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    if (isNotNull(rowId)) {
      getProcessById(rowId, appContext,
        (response: any) => {
          setTitle('Edit Process');
          setProcessData(response.data);
          setLoader(false);
          appContext.setShowLoader(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoader(false);
        });
    } else {
      setLoader(false);
    }
  }, []);

  const onSubmit = (data: any) => {
    saveProcess(data, appContext,
      (response: any) => {
        navigate('/production/process/list');
        appContext.setSuccessMessage(response.message)
        appContext.setShowLoader(false);
      }, (error: any) => {
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message)
      });
  }

  const getMainComponent = () => {
    return <Grid container spacing={1}>
      <Grid xs={3}>
        <ITextField name='processCode' label='Process Code' required={true} />
      </Grid>
      <Grid xs={3}>
        <ITextField name='process' label='Process' required={true} />
      </Grid>
      <Grid xs={3}>
        <ITextField name='remarks' label='Remarks' required={true} />
      </Grid>
    </Grid>
  }

  return loader ? <></> : <IForm formData={processData} title={title} submitForm={onSubmit} mainComponent={getMainComponent()}></IForm>
}

export default ProductionProcessForm;